module.exports = __webpack_public_path__ + "static/media/education-object-3-0-1.70b9d9fb.svg";